import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserProfile } from '../contexts/UserProfileContext';
import { menuItems, SPECIAL_EMAIL_ACCESS, canViewPageAccess } from './SideBar';

const findRequiredAuthForPath = (path) => {
  for (const item of menuItems) {
    if (item.path === path) return item.requiredAuth || [];
    if (item.submenu && item.submenu.length > 0) {
      for (const sub of item.submenu) {
        if (sub.path === path) {
          return sub.requiredAuth || item.requiredAuth || [];
        }
      }
    }
  }
  return [];
};

const RequireAuthorization = ({ children, path }) => {
  const { userAuthorization, employeeData, isRegionManager, isCenterSmoBackup, pageAccess, isLoading } = useUserProfile();
  const location = useLocation();
  const targetPath = path || location.pathname;
  const userEmail = employeeData?.eMail?.toLowerCase() || '';

  const requiredAuth = findRequiredAuthForPath(targetPath);

  const isAdmin =
    userAuthorization.includes('admin') ||
    userAuthorization.includes('Kısıtlı Admin');

  const hasAccess = () => {
    // The page-access management tool is restricted to admins ("admin" and
    // "Kısıtlı Admin") and can never be unlocked by a per-page grant
    // (prevents privilege escalation through itself).
    if (targetPath === '/sayfa-yetkileri') {
      return (
        userAuthorization.includes('admin') ||
        userAuthorization.includes('Kısıtlı Admin') ||
        // Açıkça listelenmiş kişiler (bkz. PAGE_ACCESS_VIEWERS). Bu liste
        // kod içinde sabittir; sayfanın kendisinden değiştirilemez.
        canViewPageAccess(userEmail)
      );
    }

    // Admin-managed DB grants and the hardcoded email allow-list both unlock a
    // specific page beyond the user's role.
    const specialPaths = SPECIAL_EMAIL_ACCESS[userEmail];
    if (specialPaths && specialPaths.includes(targetPath)) {
      return true;
    }
    if (Array.isArray(pageAccess) && pageAccess.includes(targetPath)) {
      return true;
    }

    // Bölge Müdürleri Raporları is restricted to admins and employees assigned
    // as bölge müdürü to a region (dynamic membership, not a static role).
    if (targetPath === '/bolge-muduru-reports') {
      return isAdmin || isRegionManager;
    }

    // SMO Lead Raporları is also accessible to employees set as a center's
    // backup (Yedek SMO), so they can view the primer SMO Lead's reports.
    if (targetPath === '/smo-lead-reports' && isCenterSmoBackup) {
      return true;
    }

    if (!requiredAuth || requiredAuth.length === 0) return true;
    return requiredAuth.some(role => userAuthorization.includes(role));
  };

  // Avoid redirecting before the user's profile/region data has loaded,
  // otherwise authorized users could be bounced to /profile prematurely.
  if (isLoading) {
    return null;
  }

  if (!hasAccess()) {
    return <Navigate to="/profile" replace />;
  }

  return children;
};

export default RequireAuthorization;


